<template>
	<ul v-if="categoryType == '1'" class="category-list">
		<li v-for="(category, index) in edgeCategories" :key="`${category.slug}-${index}`">
			<router-link :to="`/products/${category.slug}`" @click.native="flush">
				<span class="left-content">{{ category.title }}</span>
				<span class="count-text">{{ category.count }}</span>
			</router-link>
		</li>
	</ul>
	
	<ul v-else-if="categoryType == '2'" class="category-list">
		<li v-for="(item, index) in menuList" :key="`${item.name}-${index}`">
			<div @click="showToggle(item,index)">
				<router-link to="">
					<span class="left-content">{{ item.name }}</span>
					<span v-if="item.subItems.length > 0" class="count-text">{{ item.subItems.length }}</span>
					<ul v-show="item.isSubShow">
						<li v-for="subItem in item.subItems">
							<div>
								<router-link to="#">
									<span class="count-text">{{subItem.name}}</span>
								</router-link>
							</div>							
						</li>
					</ul>
				</router-link>
			</div>
		</li>
	</ul>

	<div v-else-if="categoryType == '3'" class="category-list">
		<aside>
			<ul>
				<li v-for="(item,index) in menuList" style="padding-bottom: 5px;">
					<div @click="showToggle(item,index)" style="display: flex;justify-content: space-between;">
						<span class="left-content">{{ item.name }}</span>
						<span class="count-text" v-if="item.subItems.length > 0">{{ item.subItems.length }}</span>
						<!-- <router-link to="">
							<span class="left-content">{{ item.name }}</span>
							<span v-if="item.subItems.length > 0" class="count-text">{{ item.subItems.length }}</span>
						</router-link> -->
					</div>
					<!-- start 次级菜单 -->
					<ul v-show="item.isSubShow">
						<li v-for="(subItem,subIndex) in item.subItems" style="padding-bottom: 5px;">
							<div @click="showToggle(subItem,subIndex)">			
								<span style="margin-left: 20px;">{{subItem.name}}</span>
								<!-- <router-link :to="`/products/${subItem.slug}`">
									<span style="margin-left: 20px;">{{subItem.name}}</span>
								</router-link> -->
							</div>
						</li>
					</ul>
					<!-- end 次级菜单 -->
				</li>
			</ul>
		</aside>
	</div>
	

	<div v-else-if="categoryType == '4'" class="asideBox">
		<aside>
			<ul class="asideMenu">
				<li v-for="(item,index) in menuList">
					<div class="oneMenu" @click="showToggle(item,index)">
						<router-link to="">
							<span class="count-text">{{item.name}}</span>
						</router-link>
					</div>
					<ul v-show="item.isSubShow">
						<li v-for="subItem in item.subItems">
							<div class="oneMenuChild">							
								<router-link to="#">
									<span class="count-text">{{subItem.name}}</span>
								</router-link>
							</div>
						</li>
					</ul>
				</li>
			</ul>
		</aside>
	</div>

</template>

<script>
	import BlogPostMixin from '../../mixins/BlogPostMixin'

	export default {
		name: 'BlogCategories',
		props:{
			categoryType: {
				type: String,
				default: '1'
			},
		},
		mixins: [BlogPostMixin],
		data() {
			return {
				edgeCategories: [{
						slug: '1',
						title: '边缘控制器',
						count: '2'
					},
					{
						slug: '2',
						title: 'MAC中型控制器',
						count: '3'
					},
					{
						slug: '3',
						title: 'MAC运动控制器',
						count: '6'
					},
					{
						slug: '4',
						title: 'CIO小型控制器',
						count: '4'
					},
					{
						slug: '5',
						title: '扩展IO模块',
						count: '7'
					},
					{
						slug: '6',
						title: '嵌入控制器',
						count: '4'
					},
					{
						slug: '7',
						title: '扩展IO模块',
						count: '7'
					},
					{
						slug: '8',
						title: '软件产品',
						count: '2'
					}
				],

			}
		},
		methods: {
			flush: function() {
				this.$router.go(0);
			},
			// 点击展开折叠菜单事件
			showToggle: function(item, ind) {
				
				if(item.subItems == undefined || item.subItems.length <= 0){
					this.getCategoriesData(item.slug);
					return;
					// this.$router.push({path:'/products/'+item.slug+''});
					// this.$router.push({name:'Edge Products With ID',params:{categoryID:item.slug}});
				}
				
				this.menuList.forEach(i => {
					// 判断如果数据中的menuList[i]的show属性不等于当前数据的isSubShow属性那么menuList[i]等于false
					if (i.isSubShow !== this.menuList[ind].isSubShow) {
						i.isSubShow = false;
					}
				});
				item.isSubShow = !item.isSubShow;
			},
		}
	}
</script>

<style lang="scss" scoped>
	// ul{
	// 	li{
	// 		font-size: 30px;
	// 		font-weight: 500;
	// 		padding-top: 0px;
	// 		padding-bottom: 0px;
	// 	}
	// }
	
  // $menuBackColor:#f1f1f1;
  // $menuListH2:#8fbfef;
  // .asideBox{
  //   height: 100%;
  //   width: 300px;
  //   aside{
  //     background: $menuBackColor;
  //     height: 100%;
  //     .asideMenu{
  //       .oneMenu{
  //         height: 50px;
  //         line-height: 50px;
  //         font-size: 18px;
  //         font-weight: normal;
  //         color: #ffffff;
  //         // background: $menuListH2 url("../assets/images/icon-open.png") no-repeat 280px center;
  //         border-bottom: 1px solid #669cd9;
  //         img{
  //           width: 20px;
  //           height: 20px;
  //           margin: 15px 16px 15px 20px;
  //           vertical-align: top;
  //         }
  //       }
  //       .oneMenuChild{
  //         padding: 0 20px 0 60px;
  //         height: 40px;
  //         line-height: 40px;
  //         background: $menuBackColor;
  //         border-bottom: 1px solid #ffffff;
  //         color: #454343;
  //         font-size: 18px;
  //       }
		
  //     }
  //   }
  // }
</style>